import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { normalizeVideo } from './normalizeVideo';
export var modelizeVideo = function modelizeVideo(article) {
  var _article$revision$cre;
  return {
    author: article.author,
    alias: article.alias,
    body: article.body,
    type: article.type,
    title: article.title,
    subtitle: article.body.metadata.description,
    video: normalizeVideo(article.body.url),
    date: (_article$revision$cre = article.revision.created) !== null && _article$revision$cre !== void 0 ? _article$revision$cre : null
  };
};